module.exports = __webpack_public_path__ + "img/logo_invertido.d609b17d.png";